module.exports = __webpack_public_path__ + "img/logo_landing.9b5dd59a.png";